// Firebase 模块统一入口
import { 
    initFirebaseCore, 
    firebaseService,
    getFirebaseApp,
    getFirebaseAnalytics,
    getFirebaseDatabase,
    FirebaseCore,
} from './core';

import { 
    initFirebaseMessaging, 
    firebaseMessagingService,
    requestNotificationPermissionManually 
} from './messaging';

// 导出核心服务
export {
    // 核心服务
    initFirebaseCore,
    firebaseService,
    getFirebaseApp,
    getFirebaseAnalytics,
    getFirebaseDatabase,
    
    // 消息服务
    initFirebaseMessaging,
    firebaseMessagingService,
    requestNotificationPermissionManually
};

export type { FirebaseCore };

// 初始化 Firebase（核心功能立即初始化）
export async function initFirebase() {
    console.log('开始初始化 Firebase 核心服务...');
    const coreServices = await initFirebaseCore();
    return coreServices;
}

// 初始化 PWA 相关功能（仅在 PWA 模式下调用）
export async function initFirebasePWA() {
    console.log('开始初始化 Firebase PWA 功能...');
    await initFirebaseMessaging();
}

// 默认导出初始化函数（保持向后兼容）
export default initFirebase;